import React, { useState } from "react";
import styled from "styled-components";
import { FormValues } from "../types";

interface CopyPopupProps {
  audioFiles: any[];
  currentValues: FormValues;
  onApply: (copiedData: Partial<FormValues>) => void;
}

export const CopyPopup = ({ audioFiles, currentValues, onApply }: CopyPopupProps) => {
  const [selectedFields, setSelectedFields] = useState<string[]>([]);

  const toggleField = (field: string) => {
    setSelectedFields(prev =>
      prev.includes(field) ? prev.filter(f => f !== field) : [...prev, field]
    );
  };

  function setValueSafe<T, K extends keyof T>(
    target: Partial<T>,
    key: K,
    value: unknown
  ) {
    if (value != null) {
      target[key] = value as T[K];
    }
  }


  const handleSave = () => {
    const copied: Partial<FormValues> = {};

    selectedFields.forEach((field) => {
      const value = currentValues[field as keyof FormValues];
      setValueSafe(copied, field as keyof FormValues, value);
    });

    onApply(copied);
  };

  const fields = [
    { key: "All fields", label: "All fields" },
    { key: "Additional artist", label: "Additional artist" },
    { key: "Track title", label: "Track title" },
    { key: "Track language", label: "Track language" },
    { key: "Genre", label: "Genre" },
    { key: "ISRC", label: "ISRC" },
    { key: "Artist", label: "Artist" },
    { key: "Featuring", label: "Featuring" },
    { key: "Track version", label: "Track version" },
    { key: "Contributors", label: "Contributors" },
    { key: "Additional genres", label: "Additional genres" },
    { key: "Track lyrics", label: "Track lyrics" },

  ];
  const firstColumn = fields.slice(0, 6);
  const secondColumn = fields.slice(6, 12);
  return (
    <PopupContainer>
      <Title><span>Copy from:</span> 2. My_Agenda.wav</Title>
      <Box>
        <Text>Apply to </Text>
        <div>
          <label key={'All tracks'}>
            <input
              type="checkbox"
              checked={selectedFields.includes('All tracks')}
              onChange={() => toggleField('All tracks')}
            />
            {'All tracks'}

          </label>

          <label key={'Boylife in EU.wav'}>
            <input
              type="checkbox"
              checked={selectedFields.includes('3.Boylife in EU.wav')}
              onChange={() => toggleField('Boylife in EU.wav')}
            />
            {'3.Boylife in EU.wav'}

          </label>
        </div>
      </Box>
      <TextFields>Fields</TextFields>
      <Fields>
        <Column>
          {firstColumn.map(field => (
            <label key={field.key}>
              <input
                type="checkbox"
                checked={selectedFields.includes(field.key)}
                onChange={() => toggleField(field.key)}
              />
              {field.label}
            </label>
          ))}
        </Column><Column>
          {secondColumn.map(field => (
            <label key={field.key}>
              <input
                type="checkbox"
                checked={selectedFields.includes(field.key)}
                onChange={() => toggleField(field.key)}
              />
              {field.label}
            </label>
          ))}
        </Column>
      </Fields>
      <Footer>
        <div onClick={handleSave}>Save</div>
      </Footer>
    </PopupContainer>
  );
};

const PopupContainer = styled.div`
  position: absolute;
  top: 62px;
  right: 18px;
  background: white;
  border-radius: 12px;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const Fields = styled.div`
  display: flex;
  gap:43px;
  padding: 12px;

  label {
    margin-bottom: 8px;
    font-size: 14px;
    cursor: pointer;
  }
`;

const Title = styled.div`
  width:100%;
  height: 52px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  color:#000000;
  border-bottom:1px solid #00000033;
  padding: 17px 15px;

  span{
    color:#A4A4A4;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;


const Footer = styled.div`
  width:100%;
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  color:#000000;
  border-top:1px solid #00000033;
  padding: 17px 15px;
  display:flex;
  justify-content: flex-end;

  div{
    width: 71px;
    height: 35px;
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: #6777FF;
    font-family: SF Pro Display;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: #FFFFFF;
  }
`

const Text = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  color:#000000;
  padding-bottom:12px;
`
const Box = styled.div`
  padding:12px;
  div{
    display:flex;
    gap:72px
  }
`
const TextFields = styled.div`
  padding-left:15px;
`